import { useTranslation } from 'react-i18next';

/**
 * Resolving Conflicts State Component
 * Displayed when user is actively reviewing and resolving data conflicts
 */
export function ResolvingConflictsState() {
  const { t } = useTranslation('authenticated.settings');

  return (
    <div className="flex flex-col gap-1">
      <span className="font-medium">{t('pages.integrations.status.resolving.title')}</span>
      <span className="text-sm text-muted-foreground">
        {t('pages.integrations.status.resolving.subtitle')}
      </span>
    </div>
  );
}
